// src/utils/scoreConfig.ts

export interface ScoreWeights {
  streams: number;
  listeners: number;
  saves: number;
  playlists: number;
}

export interface ScoreConfig {
  maxStreams: number;
  maxListeners: number;
  maxSaves: number;
  maxPlaylists: number;
  weights: ScoreWeights;
}

// Konfiguration für die Score-Berechnung
export const SCORE_CONFIG = {
  streams:     { weight: 0.20, scale: 5_000_000 },
listeners:   { weight: 0.20, scale: 2_000_000 },
saves:       { weight: 0.25, scale: 200_000 },
playlists:   { weight: 0.25, scale: 50_000 },
saveRate:    { weight: 0.10, scale: 0.05 }
};
